import _ from 'lodash';
import { Platform } from 'react-native';
import firebase from 'firebase/app';
import '@firebase/functions';
import '@firebase/auth';
import '@firebase/remote-config';
import { head, compose, path } from 'ramda';
// import messaging from '@react-native-firebase/messaging';

import { getExpoBundleVersion } from 'utils/system';

const firebaseConfig = __DEV__
  ? {
      apiKey: 'AIzaSyAF_OSUgUQgVixoIio2TRE4vy-Zwp6Lyus',
      authDomain: 'tikfans-hk.firebaseapp.com',
      databaseURL: 'https://tikfans-hk.firebaseio.com',
      projectId: 'tikfans-hk',
      storageBucket: 'tikfans-hk.appspot.com',
      messagingSenderId: '359885996311',
      appId: '1:359885996311:web:7e8173fa659f1fa04af752',
      measurementId: 'G-0M8QC4SWTY',
    }
  : {
      apiKey: 'AIzaSyAZqmylIOE4fQmf0pemugc2iBH33rSeMkg',
      authDomain: 'tikfans-prod-a3557.firebaseapp.com',
      databaseURL: 'https://tikfans-prod-a3557.firebaseio.com',
      projectId: 'tikfans-prod-a3557',
      storageBucket: 'tikfans-prod-a3557.appspot.com',
      messagingSenderId: '95733724385',
      appId: '1:95733724385:web:a30452b9c4c4154c3533a0',
      measurementId: 'G-KHCXNBWJM0',
    };

if (firebase.apps.length === 0) {
  try {
    firebase.initializeApp(firebaseConfig);
    // firebase.firestore().enablePersistence({ synchronizeTabs: true });
    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 60 * 1000 * 15;
    remoteConfig.fetchAndActivate();
  } catch (e) {
    if (__DEV__) {
      console.log('Init firebase error', e);
    }
  }
}

const functions = firebase.functions;
const remoteConfig = firebase.remoteConfig;
const auth = firebase.auth;

// const getRemoteConfigValue = async ({ parameter, defaultValue }) => {
//   try {
//     if (defaultValue) {
//       remoteConfig().defaultConfig = {
//         [parameter]: defaultValue,
//       };
//     }
//     const value = remoteConfig().getValue(parameter);
//     return value;
//   } catch (e) {
//     if (__DEV__) {
//       console.log('remoteConfig parameter error', e);
//     }
//     return defaultValue;
//   }
// };

export const getOrders = async ({ type = 'followers', retry = 0, followingListObject = {} }) => {
  const callable = functions().httpsCallable('getOrders');
  const res = await callable({ type, followingListObject });
  return res?.data;
};

export const getAuthUserId = async () => {
  try {
    const uid = auth().currentUser?.uid;
    if (!uid) {
      const { user } = await auth().signInAnonymously();
      return user?.uid;
    }
    return uid;
  } catch (e) {
    if (__DEV__) {
      console.log('getAuthUserId error', e);
    }
  }
};

export const updateUserStars = async ({ stars, uniqueId, ...payload }) => {
  const callable = functions().httpsCallable('updateUserStars');
  const res = await callable({ stars, uniqueId, ...payload });
  return res?.data;
};

export const updateUserAppleId = async ({ appleId, uid, ...payload }) => {
  const data = {
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    uid,
    appleId,
    ...payload,
  };
  const callable = functions().httpsCallable('updateUserInfo');
  const res = await callable(data);
  return res?.data;
};

export const updateUserInfo = async data => {
  const callable = functions().httpsCallable('updateUserInfo');
  const res = await callable(data);
  return res?.data;
};

export const getUserInfoByAppleId = async appleId => {
  try {
    const callable = functions().httpsCallable('getUserInfoByAppleId');
    const res = await callable({ appleId });
    return res?.data;
  } catch (e) {
    if (__DEV__) {
      console.log('getUserInfoByAppleId error', e);
    }
    return undefined;
  }
};

export const createUserDbRecord = async ({ uniqueId }) => {
  const callable = functions().httpsCallable('createUser');
  const res = await callable({ uniqueId });
  return res?.data;
};

export const getUserInfo = async () => {
  try {
    const callable = functions().httpsCallable('getUserInfo');
    const res = await callable();
    return res?.data;
  } catch (e) {
    console.log('getUserInfo error', e);
    return { stars: 0, hasUserDbRecord: false };
  }
};

export const createOrder = async ({
  type,
  selectedItem,
  tiktokProfile,
  orderCount,
  hasPurchased = false,
  canMakePaymentsWithActiveCard = false,
  regionName,
}) => {
  try {
    const callable = functions().httpsCallable('createOrder');
    const res = await callable({
      tiktokProfile,
      orderCount,
      hasPurchased,
      regionName,
      selectedItem,
      type,
      version: getExpoBundleVersion(),
    });
    return res?.data;
  } catch (e) {
    console.log('createOrder error', e);
  }
};

export const updateOrderStatus = async ({ orderId }) => {
  try {
    const updateOrderFunction = functions().httpsCallable('updateOrderStatus');
    await updateOrderFunction({ orderId });
  } catch (e) {
    console.log('updateOrderStatus error', e);
  }
};

export const onAuthStateChanged = () => {
  return new Promise((resolve, reject) => {
    auth().onAuthStateChanged(async user => {
      if (!user) {
        const newUser = await auth()
          .signInAnonymously()
          .catch(e => reject(e));

        resolve(newUser);
      } else {
        resolve({ user });
      }
    });
  });
};

export const getLoginUserTikTokInfo = async ({ username }) => {
  const functionName = 'getLoginUserTikTokInfo';
  const callable = functions().httpsCallable(functionName);
  const res = await callable({ username });
  return res?.data;
};

export const getTikTokUserInfo = async ({ username }) => {
  const functionNames = _.shuffle([
    'getTikTokUserInfo',
    // 'getTikTokUserInfo1',
    // 'getTikTokUserInfo2',
    // 'getTikTokUserInfo3',
    // 'getTikTokUserInfo4',
    // 'getTikTokUserInfo5',
    // 'getTikTokUserInfo6',
  ]);
  const functionName = functionNames[0];

  const callable = functions().httpsCallable(functionName);
  const res = await callable({ username });
  return res?.data;
};

export const getUserTikTokVideoList = async ({ uniqueId }) => {
  const callable = functions().httpsCallable('getUserTikTokVideoList');
  const res = await callable({ uniqueId });
  return res?.data;
};

export const getServerTime = async ({ timezone }) => {
  const callable = functions().httpsCallable('getServerTime');
  const res = await callable({ timezone });
  return res?.data;
};

export const handlePayByPrime = async ({ getPrimeResult, product, buyer, isDev }) => {
  const callable = functions().httpsCallable('handlePayByPrime');
  const res = await callable({
    getPrimeResult,
    product,
    buyer,
    isDev,
    frontend_redirect_url: __DEV__
      ? 'https://31c4-123-51-173-132.ngrok.io'
      : window.location.origin,
  });
  return res?.data;
};

export const getUserTransactionByBankTxId = async ({ bankTxId }) => {
  const functionName = 'getUserTransactionByBankTxId';
  const callable = functions().httpsCallable(functionName);
  const res = await callable({ bankTxId });
  return res?.data;
};

export const getTapPayRecord = async ({ recTradeId, isDev }) => {
  const callable = functions().httpsCallable('tapPayRecord');
  const res = await callable({ isDev, rec_trade_id: recTradeId });
  return compose(head, path(['data', 'trade_records']))(res);
};

export const fulfillByTxID = async ({ txId }) => {
  const functionName = 'fulfillByTxID';
  const callable = functions().httpsCallable(functionName);
  const res = await callable({ txId });
  return res?.data;
};

export const getVideoFromLink = async ({ url }) => {
  const callable = functions().httpsCallable('getVideoFromLink');
  const res = await callable({ url });
  return res?.data;
};

export const slackNotificationFunction = async ({ payload, url }) => {
  try {
    const callable = functions().httpsCallable('slackNotification');
    callable({ payload, url });
  } catch (e) {
    if (__DEV__) {
      console.log('slackNotificationFunction error', e);
    }
  }
};

export const checkReturnUserInfo = async ({ uniqueId }) => {
  try {
    const callable = functions().httpsCallable('checkReturnUserInfo');
    const res = await callable({ uniqueId });
    return res?.data;
  } catch (e) {
    if (__DEV__) {
      console.log('checkReturnUserInfo firebase error', e);
    }
    return {
      hasReviewed: true,
      hasFollowedIg: true,
      hasRedeemedPromoCode: true,
      hasRedeemedIOSFirstLoginReward: true,
      canRedeemPromoCode: false,
      referralCount: 0,
      referralStars: 0,
      subscriptions: {},
    };
  }
};

export const rewardReview = async ({ stars, uniqueId }) => {
  const callable = functions().httpsCallable('rewardReview');
  const res = await callable({ uniqueId, stars });
  return res?.data;
};

export const rewardFollowIg = async ({ stars, uniqueId }) => {
  const callable = functions().httpsCallable('rewardFollowIg');
  const res = await callable({ uniqueId, stars });
  return res?.data;
};

export const rewardDailyLogin = async ({ stars, uniqueId, date, dailyRewardCount }) => {
  const callable = functions().httpsCallable('rewardDailyLogin');
  const res = await callable({ uniqueId, stars, dailyRewardCount, date });
  return res?.data;
};

// export const registerAppWithFCM = async () => {
//   if (Platform.OS !== 'web') {
//     await messaging().registerDeviceForRemoteMessages();
//     if (__DEV__) {
//       // console.log('registerAppWithFCM');
//     }
//   }
// };

export const verifyPromoCode = async (promoCode, uniqueId) => {
  if (promoCode === uniqueId) {
    return {
      isPromoCodeValid: false,
    };
  }
  const callable = functions().httpsCallable('verifyPromoCode');
  const res = await callable({ promoCode });
  return res?.data;
};

export const redeemPromoCode = async ({ stars, uniqueId, referrerUid }) => {
  const callable = functions().httpsCallable('redeemPromoCode');
  const res = await callable({ stars, uniqueId, referrerUid });
  return res?.data;
};

export const redeemIOSFirstLoginReward = async ({ uniqueId, stars }) => {
  const callable = functions().httpsCallable('redeemIOSFirstLoginReward');
  const res = await callable({ uniqueId, stars });
  return res?.data;
};

export const flagUserHasUsedWithIOSReward = async ({ used = true }) => {
  const callable = functions().httpsCallable('flagUserHasUsedWithIOSReward');
  const res = await callable({ used });
  return res?.data;
};

export const checkOrderTikTokStatus = async ({ orderId, order }) => {
  try {
    const callable = functions().httpsCallable('checkOrderTikTokStatus');
    await callable({ orderId, ...order });
  } catch (e) {
    if (__DEV__) {
      console.log('checkOrderTikTokStatus error', e);
    }
  }
};

export const createTransactionRecord = async payload => {
  try {
    const callable = functions().httpsCallable('createTransactionRecord');
    const res = await callable(payload);
    return res?.data;
  } catch (e) {
    console.log('createTransactionRecord error', e);
  }
};

export const getPercentageUseAPI = async () => {
  const callable = functions().httpsCallable('getRemoteConfig');
  try {
    const value = await callable({ param: 'percentageUseAPI' });
    return JSON.parse(value.data);
  } catch (e) {
    console.log('fetch remote config error');
    return {
      video: 0,
      user: 0,
    };
  }
};
